/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrokerDto } from '../models/BrokerDto';
import type { OfficeBlockDto } from '../models/OfficeBlockDto';
import type { OfficeDropDownDto } from '../models/OfficeDropDownDto';
import type { OfficeDto } from '../models/OfficeDto';
import type { OfficeLiteDto } from '../models/OfficeLiteDto';
import type { OfficeSearchDto } from '../models/OfficeSearchDto';
import type { OfficeSearchResult } from '../models/OfficeSearchResult';
import type { SiteVisionNewsDto } from '../models/SiteVisionNewsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OfficeService {

    /**
     * @param customerId
     * @returns OfficeDto Success
     * @throws ApiError
     */
    public static officeGetOffice(
        customerId?: string,
    ): CancelablePromise<OfficeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/Getoffice',
            query: {
                'customerId': customerId,
            },
        });
    }

    /**
     * @param customerId
     * @returns OfficeLiteDto Success
     * @throws ApiError
     */
    public static officeGetOfficeLite(
        customerId?: string,
    ): CancelablePromise<OfficeLiteDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeLite',
            query: {
                'customerId': customerId,
            },
        });
    }

    /**
     * @param customerId
     * @returns BrokerDto Success
     * @throws ApiError
     */
    public static officeGetBrokersForOffice(
        customerId?: string,
    ): CancelablePromise<Array<BrokerDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetBrokersForOffice',
            query: {
                'customerId': customerId,
            },
        });
    }

    /**
     * @param name
     * @param customerId
     * @returns BrokerDto Success
     * @throws ApiError
     */
    public static officeGetBroker(
        name?: string,
        customerId?: string,
    ): CancelablePromise<BrokerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetBroker',
            query: {
                'name': name,
                'customerId': customerId,
            },
        });
    }

    /**
     * @param email
     * @returns BrokerDto Success
     * @throws ApiError
     */
    public static officeGetBrokerByEmail(
        email?: string,
    ): CancelablePromise<BrokerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetBrokerByEmail',
            query: {
                'email': email,
            },
        });
    }

    /**
     * @param customerId
     * @returns OfficeBlockDto Success
     * @throws ApiError
     */
    public static officeGetOfficeBlock(
        customerId?: string,
    ): CancelablePromise<OfficeBlockDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeBlock',
            query: {
                'customerId': customerId,
            },
        });
    }

    /**
     * @returns OfficeBlockDto Success
     * @throws ApiError
     */
    public static officeGetOfficeBlockList(): CancelablePromise<Array<OfficeBlockDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeBlockList',
        });
    }

    /**
     * @param county
     * @param customerId
     * @param category
     * @param news
     * @returns SiteVisionNewsDto Success
     * @throws ApiError
     */
    public static officeGetSiteVisionNews(
        county?: string,
        customerId?: string,
        category?: string,
        news?: string,
    ): CancelablePromise<SiteVisionNewsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetSiteVisionNews',
            query: {
                'county': county,
                'customerId': customerId,
                'category': category,
                'news': news,
            },
        });
    }

    /**
     * @returns string Success
     * @throws ApiError
     */
    public static officeGetOfficeDropdownName(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeDropdownName',
        });
    }

    /**
     * @returns OfficeDropDownDto Success
     * @throws ApiError
     */
    public static officeGetOfficeDropdown(): CancelablePromise<Array<OfficeDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeDropdown',
        });
    }

    /**
     * @param regionId
     * @returns OfficeDropDownDto Success
     * @throws ApiError
     */
    public static officeGetOfficesForRegion(
        regionId?: number,
    ): CancelablePromise<Array<OfficeDropDownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficesForRegion',
            query: {
                'regionId': regionId,
            },
        });
    }

    /**
     * @param longitud
     * @param latitud
     * @returns OfficeBlockDto Success
     * @throws ApiError
     */
    public static officeGetOfficeNearMe(
        longitud?: number,
        latitud?: number,
    ): CancelablePromise<Array<OfficeBlockDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetOfficeNearMe',
            query: {
                'longitud': longitud,
                'latitud': latitud,
            },
        });
    }

    /**
     * @param query
     * @returns OfficeSearchDto Success
     * @throws ApiError
     */
    public static officeSearchBrokerAndOfficeByQuery(
        query?: string,
    ): CancelablePromise<OfficeSearchDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/SearchBrokerAndOfficeByQuery',
            query: {
                'query': query,
            },
        });
    }

    /**
     * @param query
     * @returns OfficeSearchResult Success
     * @throws ApiError
     */
    public static officeBrokerSearch(
        query?: string,
    ): CancelablePromise<OfficeSearchResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/BrokerSearch',
            query: {
                'query': query,
            },
        });
    }

    /**
     * @param brokerId
     * @returns string Success
     * @throws ApiError
     */
    public static officeGetBrokerUrlByBrokerId(
        brokerId?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetBrokerUrlByBrokerId',
            query: {
                'brokerId': brokerId,
            },
        });
    }

    /**
     * @param email
     * @returns string Success
     * @throws ApiError
     */
    public static officeGetBrokerUrl(
        email?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Office/GetBrokerUrl',
            query: {
                'email': email,
            },
        });
    }

}
